import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    googletag: {
      cmd: Array<() => void>;
      display: (divId: string) => void;
      pubads: () => {
        refresh: (slots?: unknown[]) => void;
        getTargeting: (key: string) => string[];
      };
    };
  }
}

interface AdBannerProps {
  slotId: string;
  className?: string;
}

export function AdBanner({ slotId, className = '' }: AdBannerProps) {
  const adRef = useRef<HTMLDivElement>(null);
  const isDisplayed = useRef(false);

  useEffect(() => {
    // Wait for DOM element to be ready
    const displayAd = () => {
      if (!isDisplayed.current && adRef.current && window.googletag && window.googletag.cmd) {
        window.googletag.cmd.push(() => {
          window.googletag.display(slotId);
          isDisplayed.current = true;
          
          // Log targeting for debugging (SDK v5.11: only adwall=true for recovered users)
          const adwallValue = window.googletag.pubads().getTargeting('adwall');
          console.log('[AdBanner] adwall key-value:', adwallValue);
        });
      }
    };

    // Small delay to ensure DOM is fully rendered
    const timer = setTimeout(displayAd, 100);
    return () => clearTimeout(timer);
  }, [slotId]);

  return (
    <div className={`ad-banner-container ${className}`}>
      <div 
        id={slotId} 
        ref={adRef}
        style={{ 
          minWidth: '300px', 
          minHeight: '250px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f0f0f0',
          border: '1px dashed #ccc'
        }}
      >
        {/* GPT will render ad here */}
      </div>
      <p className="text-xs text-gray-500 mt-1 text-center">Publicité</p>
    </div>
  );
}
